export default __webpack_public_path__ + "static/media/signature_manager.1033db46.png";